import React, { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../contexts/AppContext";
import VideoThumbnailExtractor from "../PropertyList/VideoThumbnailExtractor";
import { deleteData, postData, putData } from "../../lib/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import ReplaceVideo from "../Gallery/ReplaceVideo";

function VideoThumbnail() {
  
  const { value } = useContext(Context);
  const [appState, setAppState] = value;

  const [menuOpenState, setMenuOpenState] = useState({});
  const [thumbStatus, setThumbStatus] = useState({}); // checking | ok | generate

  const menuRef = useRef(null);

  

  const MAX_RETRY = 3;
  const RETRY_DELAY = 3000; // 3 sec
  const retryRef = useRef({});

  const MAX_VIDEO_RETRY = 5;
const VIDEO_RETRY_DELAY = 3000;
const imgRefs = useRef({});

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

 

 const videoCheckRef = useRef({});
const isMountedRef = useRef(true);

useEffect(() => {
  return () => {
    isMountedRef.current = false; // stop all loops on unmount
  };
}, []);



//useEffect k andar k function tabhi call honge jab dispatch event call hoga 
//------- START OF DISPATCH FUNCTION ---------
useEffect(() => {
  let isUnmounted = false;

 const pollThumbnail = async (videoId, thumbnailUrl) => {
  if (isUnmounted) return;

  try {
    const res = await postData("products/check-file", {
      fileName: thumbnailUrl,
    });

    if (res.exists) {
      setThumbStatus((prev) => ({
        ...prev,
        [videoId]: "ok",
      }));

      // 🔥 FORCE IMAGE RELOAD
      const img = imgRefs.current[videoId];
      if (img) {
        img.src = ""; // reset
        img.src = `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${thumbnailUrl}?t=${Date.now()}`;
        img.style.display = "block";
      }

      return;
    }
  } catch (err) {
    console.error(err);
  }

  setTimeout(() => {
    pollThumbnail(videoId, thumbnailUrl);
  }, 3000);
};

  const handleThumbUpdate = (event) => {
    const { videoId, thumbnailUrl } = event.detail;

    setThumbStatus((prev) => ({
      ...prev,
      [videoId]: "checking",
    }));

    pollThumbnail(videoId, thumbnailUrl);
  };

  window.addEventListener("thumbnail-updated", handleThumbUpdate);

  return () => {
    isUnmounted = true;
    window.removeEventListener("thumbnail-updated", handleThumbUpdate);
  };
}, []);
// ----------END OF USE EFFECT DISPATCH FUNCTION ------


  // -------------------------------
  // MENU OUTSIDE CLICK
  // -------------------------------
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpenState({});
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleMenu = (videoId, e) => {
    e.stopPropagation();
    setMenuOpenState((prev) => ({ [videoId]: !prev[videoId] }));
  };

  // -------------------------------
  // CHECK THUMBNAIL ON S3 (WITH RETRY)
  // -------------------------------
// -------------------------------
// CHECK VIDEO ON S3 BEFORE GENERATE (with retry & lock)
// -------------------------------
const checkVideoOnS3BeforeGenerate = async (item) => {
  const id = item._id;

  // 🚫 Skip if already generating/replacing
  if (thumbStatus[id] === "generate" || thumbStatus[id] === "replacing") return;

  // Initialize retry counter and lock
  if (!retryRef.current[id]) retryRef.current[id] = { count: 0, locked: false };
  if (retryRef.current[id].locked) return; // already running
  retryRef.current[id].locked = true;

  const attemptCheck = async () => {
    // Always mark as checking while processing
    setThumbStatus((prev) => ({
      ...prev,
      [id]: "checking",
    }));

    try {
      const res = await postData("products/check-file", { fileName: item.url });

      if (res.exists) {
        console.log("VIDEO FOUND ON S3 Destination");
        setThumbStatus((prev) => ({
          ...prev,
          [id]: "generate", // ready to generate thumbnail
        }));
        retryRef.current[id] = { count: 0, locked: false }; // reset
        return;
      }

      // Retry logic
     // retryRef.current[id].count += 1;
      if (retryRef.current[id].count < MAX_VIDEO_RETRY) {
        setTimeout(attemptCheck, VIDEO_RETRY_DELAY);
      } else {
        console.warn(`Video check failed after ${MAX_VIDEO_RETRY} retries`);
        retryRef.current[id].locked = false;
      }
    } catch (err) {
      console.error("Video S3 check failed", err);

      retryRef.current[id].count += 1;
      if (retryRef.current[id].count < MAX_VIDEO_RETRY) {
        setTimeout(attemptCheck, VIDEO_RETRY_DELAY);
      } else {
        console.warn(`Video check failed after ${MAX_VIDEO_RETRY} retries`);
        retryRef.current[id].locked = false;
      }
    }
  };

  attemptCheck();
};

// -------------------------------
// CHECK THUMBNAIL ON S3 (with retry & lock)
// -------------------------------
const checkThumbnailOnS3 = async (item, imgEl) => {
  const id = item._id;

  // 🚫 Skip if thumbnail is already OK or being processed
  if (thumbStatus[id] === "ok" || thumbStatus[id] === "replacing") return;

  // Initialize retry counter and lock
  if (!retryRef.current[`thumb_${id}`]) retryRef.current[`thumb_${id}`] = { count: 0, locked: false };
  if (retryRef.current[`thumb_${id}`].locked) return; // already running
  retryRef.current[`thumb_${id}`].locked = true;

  const attemptCheck = async () => {
    setThumbStatus((prev) => ({
      ...prev,
      [id]: "checking",
    }));

    try {
      const res = await postData("products/check-file", { fileName: item.thumbnail });

      if (res.exists) {
        console.log("THUMBNAIL FOUND ON S3", item.thumbnail);
        setThumbStatus((prev) => ({ ...prev, [id]: "ok" }));

        // Force reload the image
        if (imgEl) {
          imgEl.src = "";
          imgEl.src = `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${item.thumbnail}?t=${Date.now()}`;
          imgEl.style.display = "block";
        }

        retryRef.current[`thumb_${id}`] = { count: 0, locked: false };
        return;
      }

      // Retry
      retryRef.current[`thumb_${id}`].count += 1;
      if (retryRef.current[`thumb_${id}`].count < MAX_RETRY) {
        setTimeout(attemptCheck, RETRY_DELAY);
      } else {
        console.warn(`Thumbnail check failed after ${MAX_RETRY} retries`);
        setThumbStatus((prev) => ({ ...prev, [id]: "generate" }));
        retryRef.current[`thumb_${id}`].locked = false;
      }
    } catch (err) {
      console.error("Thumbnail S3 check failed", err);
      retryRef.current[`thumb_${id}`].count += 1;

      if (retryRef.current[`thumb_${id}`].count < MAX_RETRY) {
        setTimeout(attemptCheck, RETRY_DELAY);
      } else {
        setThumbStatus((prev) => ({ ...prev, [id]: "generate" }));
        retryRef.current[`thumb_${id}`].locked = false;
      }
    }
  };

  attemptCheck();
};



const replaceStart=(videoId)=>{
    setThumbStatus((prev) => ({
      ...prev,
      [videoId]: "replacing",
    }));

 
}

  // -------------------------------
  // DELETE VIDEO
  // -------------------------------
  const deleteVideo = async (videoUrl, videoId) => {
    if (!window.confirm("Are you sure you want to delete this video?")) return;

    try {
      await postData("products/delete-file", { fileName: videoUrl });
      await deleteData(`videos/deleteVideo/${videoId}`);

      setAppState((prev) => ({
        ...prev,
        videoArr: prev.videoArr.filter((v) => v._id !== videoId),
      }));

      setThumbStatus((prev) => {
        const copy = { ...prev };
        delete copy[videoId];
        return copy;
      });
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  // -------------------------------
  // REPLACE VIDEO
  // -------------------------------
const replaceUploadVideoDone = async (
  fileName,
  uniqueId,
  videoId,
  oldVideoUrl
) => {
  try {
    const newUrl = `${appState.currentFolderData.adminId}/${appState.currentFolderData.id}/${appState.currentGalleryData._id}/${fileName}`;

    

    await putData(`videos/updateVideo/${videoId}`, { url: newUrl });
    await postData("products/delete-file", { fileName: oldVideoUrl });

    const updatedVideo = {
      ...appState.videoArr.find(v => v._id === videoId),
      url: newUrl,
      thumbnail: null, // 👈 important
    };

    setAppState((prev) => ({
      ...prev,
      videoArr: prev.videoArr.map((v) =>
        v._id === videoId ? updatedVideo : v
      ),
    }));

    // 👇 thumbnail status reset
    setThumbStatus((prev) => ({
      ...prev,
      [videoId]: "checking",
    }));

    retryRef.current[videoId] = 0;

    // 👇 start checking video on S3
    checkVideoOnS3BeforeGenerate(updatedVideo);

  } catch (err) {
    console.error("Replace error:", err);
  }
};


  // -------------------------------
  // PLAYER OPEN
  // -------------------------------
  const videoThumbBtnHandler = (e) => {
    const index = e.currentTarget.id;
    const videoDBId = e.currentTarget.dataset.dbvideoid;

    setAppState((prev) => ({
      ...prev,
      currentVideoId: index,
      currentDBVideoId: videoDBId,
      modalData: { ...prev.modalData, type: "VideoPlayerModal", isOpen: true },
    }));
  };

  const formatDate = (iso) => {
    const d = new Date(iso);
    return d.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // -------------------------------
  // UI
  // -------------------------------
  return (
    <div className="flex m-4 gap-2 flex-wrap">
      {appState?.videoArr?.map((item, index) => (
        <div
          key={item._id}
          className="border rounded-lg bg-[#404143] relative h-[180px] w-80"
        >
          <div
            id={index}
            data-dbvideoid={item._id}
            className="w-full h-full cursor-pointer relative"
            onClick={videoThumbBtnHandler}
          >
            {/* IMAGE */}
           { console.log(item.thumbnail," thumbStatus== ",thumbStatus[item._id])}
            {thumbStatus[item._id] !== "generate" && (
              <img
                ref={(el) => {
    if (el) imgRefs.current[item._id] = el;
  }}
                src={`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${item.thumbnail}?t=${Date.now()}`}
                alt="thumbnail"
                className="w-full h-full object-cover rounded-lg"
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.style.display = "none";

                if (!item.thumbnail) {
                  checkVideoOnS3BeforeGenerate(item);
                  return;
                }

                  
                  //item.thubnail main value tabhi jab ek baar thumbnail save hua ho
                  if(item.thumbnail && thumbStatus[item._id] !== "ok" && thumbStatus[item._id] !== "checking")
                  {
                    
                   checkThumbnailOnS3(item, e.currentTarget);
                  }
                
                }}
              />
            )}

            {/* CHECKING OVERLAY */}
{["checking", "generate", "replacing"].includes(thumbStatus[item._id]) && (
  <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/60 rounded-lg z-10">
    <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin mb-2" />

    <span className="text-white text-xs">
      {thumbStatus[item._id] === "checking" && "Processing"}
      {thumbStatus[item._id] === "replacing" && "Generating thumbnail"}
      {thumbStatus[item._id] === "generate" && "Generating thumbnail"}
    </span>
  </div>
)}



            {/* GENERATE */}
           { console.log("THUMBBBBBBBBBBBBB ",thumbStatus[item._id])}
            {thumbStatus[item._id] === "generate" && (
              <VideoThumbnailExtractor videodata={item} />
            )}

            {/* INFO + MENU */}
            <div className="absolute bottom-2 left-0 right-0 px-2 text-white font-medium text-left">
              <div>{item.title}</div>
              <div>{formatDate(item.createdAt)}</div>

              <button
                onClick={(e) => toggleMenu(item._id, e)}
                className="absolute bottom-0 right-4"
              >
                <FontAwesomeIcon icon={faEllipsisH} />
              </button>

              {menuOpenState[item._id] && (
                <div
                  ref={menuRef}
                  className="absolute -bottom-14 right-0 w-40 bg-white rounded-lg shadow p-2 z-10"
                  onClick={(e) => e.stopPropagation()}
                >
                  <ReplaceVideo
                    oldVideoUrl={item.url}
                    videoId={item._id}
                    showProgressBar={() => {}}
                    replaceUploadVideoDone={replaceUploadVideoDone}
                    replaceStart={replaceStart}
                  />
                  <button
                    onClick={() => deleteVideo(item.url, item._id)}
                    className="flex gap-2 px-4 py-2 text-gray-700 hover:bg-gray-100 w-full"
                  >
                    <FontAwesomeIcon icon={faTrash} />
                    Delete
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default VideoThumbnail;
